import { Fragment } from 'react';
import type { GetAllPostTitles } from '@api';
import { postPath } from '@paths';

export const SimplePostList: React.FC<{
  simplePosts: Awaited<GetAllPostTitles>;
}> = ({ simplePosts }) => (
  <section>
    <div className='columns-2 mb-16 md:mb-32'>
      {simplePosts.map((post, i) => (
        <Fragment key={post.slug || i}>
          {post.slug ? (
            <a
              href={postPath(post.slug)}
              className='text-primary underline hover:text-top-primary block mb-1'
            >
              {post.title}
            </a>
          ) : (
            <></>
          )}
        </Fragment>
      ))}
    </div>
  </section>
);
